import React, {
    useState,
    useEffect,
    useContext
}
from "react";


import {
    OMNISCAN_BLUE_RGB, OMNISCAN_BLUE
} from "../constants/colors";


import EvaChat
from "../pages/eva/ai/EvaChat";

import omniscanLogoDark
from "../../images/omniscanlogo.png";

import demoClientLogo
from "../../images/democlient.png";

import {functions}
from "../constants/common-functions";

import {STRINGIFY}
from "../constants/general-constants";

import {CHANGE_QUERY_CONTEXT}
from "../constants/action-types";

import {store}
from "../context/store.js";

import {FontAwesomeIcon}
from "@fortawesome/react-fontawesome";

import {
    faChevronDown,
    faChevronUp
}
from "@fortawesome/free-solid-svg-icons";


export default function Header({
    transitionHide = false,
    showSurveySelector = false
})
{
    //--------------------------------------------------------
    // Context
    //--------------------------------------------------------

    const globalState =
        useContext(store);

    const {dispatch} =
        globalState;

    const client =
        globalState
            ? globalState.state.client
            : null;


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [clientLogo, setClientLogo] =
        useState("");

    const [hideLogos, setHideLogos] =
        useState(false);

    const [hoverSurveyId, setHoverSurveyId] =
        useState(-100);

    const [displayDropdown, setDisplayDropdown] =
        useState(false);

    const [surveys, setSurveys] =
        useState([]);

    const [surveyPosition, setSurveyPosition] =
        useState(
        {
            x: window.innerWidth - 260,
            y: 30
        });

    const [dragging, setDragging] =
        useState(false);


    //--------------------------------------------------------
    // Selected survey
    //--------------------------------------------------------

    const selectedSurvey =
        surveys.find(
            function(survey)
            {
                return (
                    survey.id ===
                    globalState?.state?.queryContext?.utilisationSurveyId
                );
            }
        ) || null;


    //--------------------------------------------------------
    // Hide logos after transition
    //--------------------------------------------------------

    useEffect(
        function()
        {
            if(!transitionHide)
            {
                return;
            }

            const timer =
                setTimeout(
                    function()
                    {
                        setHideLogos(true);
                    },
                    3000
                );

            return function()
            {
                clearTimeout(timer);
            };
        },
        [transitionHide]
    );


    //--------------------------------------------------------
    // Client logo
    //--------------------------------------------------------

    useEffect(
        function()
        {
            setClientLogo(
                demoClientLogo
            );

            if(client)
            {
                let logoSource =
                    client.resourceFolderUrl +
                    "/client_logo.png";

                functions.getFileSource(
                    logoSource,
                    setClientLogo,
                    null
                );
            }
        },
        [client]
    );


    //--------------------------------------------------------
    // Surveys
    //--------------------------------------------------------

    useEffect(
        function()
        {
            functions.getArrayFromAjax(
                "/resolutionsoftwareplatform/utilisationgetsurveys",
                function(data)
                {
                    setSurveys(data);
                },
                null
            );
        },
        []
    );


    //--------------------------------------------------------
    // User activity
    //--------------------------------------------------------

    useEffect(
        function()
        {
            functions.submitAjax(
                "/resolutionsoftwareplatform/useractivity",
                {
                    activityType: "VIEW",
                    url: location.pathname,
                    details: document.title
                },
                null,
                STRINGIFY
            );
        },
        [location.pathname]
    );


    //--------------------------------------------------------
    // Drag survey selector
    //--------------------------------------------------------

    const handleMouseDown =
        function(event)
        {
            setDragging(true);

            const startX =
                event.clientX;

            const startY =
                event.clientY;

            const startPos =
            {
                x: surveyPosition.x,
                y: surveyPosition.y
            };

            const handleMove =
                function(moveEvent)
                {
                    setSurveyPosition(
                    {
                        x:
                            startPos.x +
                            moveEvent.clientX -
                            startX,

                        y:
                            startPos.y +
                            moveEvent.clientY -
                            startY
                    });
                };

            const handleUp =
                function()
                {
                    setDragging(false);

                    document.removeEventListener(
                        "mousemove",
                        handleMove
                    );

                    document.removeEventListener(
                        "mouseup",
                        handleUp
                    );
                };

            document.addEventListener(
                "mousemove",
                handleMove
            );

            document.addEventListener(
                "mouseup",
                handleUp
            );
        };


    //--------------------------------------------------------
    // Styles
    //--------------------------------------------------------

    const thisContainer =
    {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        position: "fixed",
        top: "0px",
        left: "70px",
        width: "calc(100% - 90px)",
        height: "80px",
        zIndex: "20000",
        pointerEvents: "none"
    };


    const headerContent =
    {
        display: "flex",
        marginLeft: "10px",
        marginRight: "30px"
    };


    //--------------------------------------------------------
    // OmniScan logo panel
    //--------------------------------------------------------

    const omniscanPanel =
    {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        padding: "8px 20px",

        height: "50px",

        background:
            "rgba(255,255,255,0.92)",

        backdropFilter:
            "blur(16px)",

        WebkitBackdropFilter:
            "blur(16px)",

        borderRadius: "0px",

        border:
            "1px solid rgba(12,53,88,0.08)",

			borderBottom:
			    `2px solid rgba(${OMNISCAN_BLUE_RGB}, 0.55)`,

        boxShadow:
            "0 5px 16px rgba(7,28,49,0.10)",

        transition:
            "all 0.6s ease",

        transform:
            hideLogos
                ? "translateY(-90px)"
                : "translateY(0px)",

        opacity:
            hideLogos
                ? 0
                : 1
    };


    const omniscanLogoStyle =
    {
        display: "block",

        width: "170px",

        height: "50px",

        padding: "8px 18px",

        objectFit: "contain"
    };


    //--------------------------------------------------------
    // Right hand content
    //--------------------------------------------------------

    const rightContent =
    {
        display: "flex",

        width: "calc(100% - 500px)",

        height: "80px",

        alignItems: "center",

        flexDirection: "row-reverse"
    };


    //--------------------------------------------------------
    // Client logo panel
    //--------------------------------------------------------

    const clientLogoPanel =
    {
        display: "flex",

        alignItems: "center",

        justifyContent: "center",

        padding: "8px 16px",

        marginRight: "15px",

        marginTop: "0px",

        minHeight: "55px",

        background:
            "rgba(255,255,255,0.92)",

        backdropFilter:
            "blur(16px)",

        WebkitBackdropFilter:
            "blur(16px)",

        borderRadius: "0px",

        border:
            "1px solid rgba(12,53,88,0.08)",

			borderBottom:
			    `2px solid rgba(${OMNISCAN_BLUE_RGB}, 0.55)`,

        boxShadow:
            "0 5px 16px rgba(7,28,49,0.10)",

        transition:
            "all 0.6s ease",

        transform:
            hideLogos
                ? "translateY(-90px)"
                : "translateY(0px)",

        opacity:
            hideLogos
                ? 0
                : 1
    };


    const logoStyle =
    {
        maxWidth: "160px",

        maxHeight: "60px",

        width: "auto",

        height: "auto",

        objectFit: "contain",

        display: "block"
    };


    //========================================================
    // Survey selector - transparent glass
    //========================================================

    const surveyPill =
    {
        position: "fixed",

        left:
            surveyPosition.x + "px",

        top:
            surveyPosition.y + "px",

        width: "220px",

        minHeight: "48px",

        padding: "8px 14px",

        boxSizing: "border-box",

        borderRadius: "0px",

        //----------------------------------------------------
        // Transparent frosted glass
        //----------------------------------------------------

        background:
            "rgba(255,255,255,0.62)",

        backdropFilter:
            "blur(18px) saturate(120%)",

        WebkitBackdropFilter:
            "blur(18px) saturate(120%)",

        //----------------------------------------------------
        // Fine glass edge
        //----------------------------------------------------

        border:
            "1px solid rgba(255,255,255,0.78)",

		borderBottom:
		    `2px solid rgba(${OMNISCAN_BLUE_RGB}, 0.55)`,

        //----------------------------------------------------
        // Floating glass depth
        //----------------------------------------------------

        boxShadow:
            `
            0 8px 22px rgba(15,25,35,0.14),
            inset 0 1px 0 rgba(255,255,255,0.85)
            `,

        color:
            "#26333d",

        cursor: "move",

        userSelect: "none",

        zIndex: "25000",

        pointerEvents: "auto",

        overflow: "hidden"
    };


    //========================================================
    // Survey dropdown - slightly denser glass
    //========================================================

    const surveyDropdown =
    {
        position: "fixed",

        top:
            surveyPosition.y + 52 + "px",

        left:
            surveyPosition.x + "px",

        width: "250px",

        //----------------------------------------------------
        // Denser glass for readability
        //----------------------------------------------------

        background:
            "rgba(255,255,255,0.78)",

        backdropFilter:
            "blur(20px) saturate(120%)",

        WebkitBackdropFilter:
            "blur(20px) saturate(120%)",

        border:
            "1px solid rgba(255,255,255,0.82)",

        borderRadius: "0px",

        overflow: "hidden",

        boxShadow:
            `
            0 14px 32px rgba(15,25,35,0.16),
            inset 0 1px 0 rgba(255,255,255,0.86)
            `,

        zIndex: "25001",

        pointerEvents: "auto"
    };


    const surveyRow =
    {
        padding: "10px 14px",

        cursor: "pointer",

        color: "#35414a",

        borderBottom:
            "1px solid rgba(25,35,45,0.08)",

        transition:
            "background 0.2s ease"
    };


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div style={thisContainer}>


            {/* OmniScan logo */}

            <div style={headerContent}>

                <div style={omniscanPanel}>

                    <img
                        src={omniscanLogoDark}
                        style={omniscanLogoStyle}
                        alt="OmniScan Pro"
                    />

                </div>

            </div>


            {/* Client logo */}

            <div style={rightContent}>

                <div style={clientLogoPanel}>

                    <img
                        src={clientLogo || demoClientLogo}
                        onError={
                            function(event)
                            {
                                event.target.src =
                                    demoClientLogo;
                            }
                        }
                        style={logoStyle}
                        alt="Client"
                    />

                </div>

            </div>


            {/* Survey selector */}

            {
                surveys &&
                surveys.length > 1 &&
                showSurveySelector &&
                <div
                    style={surveyPill}
                    onMouseDown={handleMouseDown}
                >

                    {
                        selectedSurvey
                            ?
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center"
                                }}
                            >

                                <div
                                    style={{
                                        flexGrow: 1
                                    }}
                                >

                                    <div
                                        style={{
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            color: "#25313a"
                                        }}
                                    >

                                        {selectedSurvey.name}

                                    </div>

                                    <div
                                        style={{
                                            fontSize: "11px",
                                            color: "#5d6870",
                                            marginTop: "2px"
                                        }}
                                    >

                                        {
                                            functions.formatDateRange(
                                                selectedSurvey.surveyStartDate,
                                                selectedSurvey.surveyEndDate
                                            )
                                        }

                                    </div>

                                </div>


                                <div
                                    style={{
                                        padding: "6px",
                                        cursor: "pointer",

                                        //------------------------------------------------
                                        // Bright blue action accent
                                        //------------------------------------------------

                                        color: OMNISCAN_BLUE
                                    }}
                                    onClick={
                                        function(event)
                                        {
                                            event.stopPropagation();

                                            setDisplayDropdown(
                                                !displayDropdown
                                            );
                                        }
                                    }
                                >

                                    <FontAwesomeIcon
                                        icon={
                                            displayDropdown
                                                ? faChevronUp
                                                : faChevronDown
                                        }
                                    />

                                </div>

                            </div>

                            :

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between"
                                }}
                            >

                                <div
                                    style={{
                                        fontSize: "13px",
                                        color: "#5d6870"
                                    }}
                                >

                                    Select Survey

                                </div>

                                <FontAwesomeIcon
                                    icon={
                                        displayDropdown
                                            ? faChevronUp
                                            : faChevronDown
                                    }
                                    style={{
                                        color: "#2695cc"
                                    }}
                                />

                            </div>
                    }

                </div>
            }


            {/* Survey dropdown */}

            {
                displayDropdown
                    ?
                    <div style={surveyDropdown}>

                        {
                            surveys.map(
                                function(survey)
                                {
                                    if(
                                        selectedSurvey &&
                                        survey.id === selectedSurvey.id
                                    )
                                    {
                                        return null;
                                    }

                                    return (

                                        <div
                                            key={survey.id}
                                            style={{
                                                ...surveyRow,

                                                background:
                                                    hoverSurveyId === survey.id
                                                        ? "rgba(69,175,224,0.13)"
                                                        : "rgba(255,255,255,0.06)"
                                            }}
                                            onMouseEnter={
                                                function()
                                                {
                                                    setHoverSurveyId(
                                                        survey.id
                                                    );
                                                }
                                            }
                                            onMouseLeave={
                                                function()
                                                {
                                                    setHoverSurveyId(
                                                        -100
                                                    );
                                                }
                                            }
                                            onClick={
                                                function()
                                                {
                                                    dispatch(
                                                    {
                                                        type:
                                                            CHANGE_QUERY_CONTEXT,

                                                        value:
                                                        {
                                                            utilisationSurveyId:
                                                                survey.id
                                                        }
                                                    });

                                                    setDisplayDropdown(false);
                                                }
                                            }
                                        >

                                            <div
                                                style={{
                                                    fontWeight: "600",
                                                    fontSize: "13px",
                                                    color: "#27343d"
                                                }}
                                            >

                                                {survey.name}

                                            </div>

                                            <div
                                                style={{
                                                    fontSize: "11px",
                                                    color: "#69747c",
                                                    marginTop: "2px"
                                                }}
                                            >

                                                {
                                                    functions.formatDateRange(
                                                        survey.surveyStartDate,
                                                        survey.surveyEndDate
                                                    )
                                                }

                                            </div>

                                        </div>
                                    );
                                }
                            )
                        }

                    </div>

                    :

                    null
            }

        </div>
    );
}